import { useTouchscreenContext, useVenueState } from "@touchscreen/hooks";
import { ProgressBar } from "./ProgressBar.js";
import { LikeButton } from "./LikeButton.js";
import { artworkUrl } from "../lib/artwork.js";
import { Artwork } from "@touchscreen/brand-kit";
import "./NowPlayingBar.css";

/** Sticky glass bar shown on every page once a venue is selected — mirrors the kiosk's now-playing treatment. */
export function NowPlayingBar(): React.JSX.Element {
  const { nowPlaying, progress, playerOnline } = useVenueState();
  const { venue, resetVenue } = useTouchscreenContext();

  return (
    <div className="now-playing-bar">
      <span className="now-playing-bar__label">
        <span className="now-playing-bar__now-playing">Now Playing</span> at{" "}
        {venue ? (
          <button type="button" className="now-playing-bar__venue" onClick={resetVenue}>
            {venue.name}
          </button>
        ) : null}
      </span>

      {nowPlaying ? (
        <div className="now-playing-bar__row">
          <Artwork className="now-playing-bar__artwork" src={artworkUrl(nowPlaying.sm_id)} />
          <div className="now-playing-bar__info">
            <p className="now-playing-bar__track">
              {nowPlaying.title} by {nowPlaying.artist}
            </p>
            {progress ? <ProgressBar ratio={progress.ratio} /> : null}
          </div>
          <LikeButton smId={nowPlaying.sm_id} title={nowPlaying.title} artist={nowPlaying.artist} />
        </div>
      ) : (
        <p className="now-playing-bar__hint">
          {playerOnline ? "Nothing playing right now" : "The music system here isn't responding right now"}
        </p>
      )}
    </div>
  );
}
